import { Loader } from '@components/loader';
import { Merchants } from '@pages/merchants';
import { useListMerchants } from '@services/staff/acquirer/merchants/list';
import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router';
import { config } from './-merchantFiltersConfig';

function AcquirerMerchants() {
  const { acquirerId, localId } = useParams({
    from: '/u/$localId/_staff/staff/acquirers/$acquirerId/merchants',
  });
  const navigate = useNavigate();
  const { data, isPending } = useListMerchants({ acquirerId });

  if (isPending) return <Loader />;

  return (
    <Merchants
      filtersConfig={config}
      data={data}
      newRedirect={() => {
        navigate({
          to: '/u/$localId/staff/acquirers/$acquirerId/merchants/new',
          params: { acquirerId, localId },
        }).catch((err) => console.error(err));
      }}
      onRowSelect={(merchant) => {
        navigate({
          to: '/u/$localId/staff/merchants/$merchantId',
          params: { merchantId: merchant.merchantId, localId },
        }).catch((err) => console.error(err));
      }}
    />
  );
}

export const Route = createFileRoute('/u/$localId/_staff/staff/acquirers/$acquirerId/merchants')({
  component: AcquirerMerchants,
});
